import { Component } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SelectOption } from "@models/ui-models/select-options";
import {
  IBulkAppliedChange
} from "../../../../../../forms/asic-forms/bulks/base-bulk-stepper-form/base-bulk-stepper-form.component";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<IBulkAppliedChange> & {
  selectName?: ActionEvent,
}

@Component({
  selector: 'app-ag-select-change-name',
  standalone: true,
  imports: [
    FormsModule,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
  ],
  templateUrl: 'ag-select-change-name.component.html',
  styleUrl: 'ag-select-change-name.component.scss'
})
export class AgSelectChangeNameComponent implements ICellRendererAngularComp {
  params!: CellRendererParams;
  entityId = '';
  selectedOption: SelectOption | undefined;
  options: SelectOption[] = [];

  dropdownOpen = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;
    this.entityId = params.data?.entityId ?? '';
    this.selectedOption = params.data?.selectedOption;
    this.options = params.data?.options ?? [];

    return true;
  }

  get sortedOptions(): SelectOption[] {
    const sorted = this.options
      .filter(option => option.value !== this.selectedOption?.value)
      .sort((a, b) => a.label.localeCompare(b.label));

    if (this.selectedOption?.value) {
      return [this.selectedOption, ...sorted];
    }

    return sorted;
  }

  selectOption(option: SelectOption): void {
    this.selectedOption = option;
    this.params?.selectName?.({ entityId: this.entityId, selectedId: option.value });
  }

  getDropdownState(dropdownState: boolean): void {
    this.dropdownOpen = dropdownState;
  }
}
